// extracted by mini-css-extract-plugin
export var container = "_d2-0";
export var containerTopRight = "_d2-1";